import { render, staticRenderFns } from "./addQyCourse.vue?vue&type=template&id=635ca7b2&scoped=true"
import script from "./addQyCourse.vue?vue&type=script&lang=js"
export * from "./addQyCourse.vue?vue&type=script&lang=js"
import style0 from "./addQyCourse.vue?vue&type=style&index=0&id=635ca7b2&prod&lang=less"
import style1 from "./addQyCourse.vue?vue&type=style&index=1&id=635ca7b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635ca7b2",
  null
  
)

export default component.exports